export function setContact(state,contact) {
    state.mail = contact[0].valor;
    state.tel1 = contact[1].valor;
    state.tel2 = contact[2].valor;
}
